import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiFormControlLabelStyles = (variables: Variables) =>
    ({
        styleOverrides: {
            root: {
                cursor: 'default',
                alignItems: 'flex-start',
            },
            label: {
                fontSize: '0.875rem',
                cursor: 'default',
                paddingTop: '7px',
                paddingLeft: '4px',
            },
            asterisk: {
                color: variables.colors.other.text.error,
                width: '10px',
                height: '10px',
                flexShrink: 0,
                textAlign: 'left',
                lineHeight: 0,
                verticalAlign: 'top',
            },
        },
    }) as const;

export default createMuiFormControlLabelStyles;
